module.exports = __webpack_public_path__ + "static/media/female.85845566.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/female.svg
// module id = 486
// module chunks = 0